module.exports = __webpack_public_path__ + "static/img/menuPowieksz-ON.73ead4c0.png";